/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_EyebrowInputs */

const en_funnel_ob_welcome_eyebrow = /** @type {(inputs: Funnel_Ob_Welcome_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const es_funnel_ob_welcome_eyebrow = /** @type {(inputs: Funnel_Ob_Welcome_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Funnel_Ob_Welcome_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_eyebrow = /** @type {((inputs?: Funnel_Ob_Welcome_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_eyebrow(inputs)
	return en_funnel_ob_welcome_eyebrow(inputs)
});